import { Modal, TextField } from 'melp-design/components';
import { FC } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form-latest';
import { useTranslation } from 'react-i18next';
import { useCreateCustomCategoryValue } from 'store/custom-categories';
import { ModalProps } from 'store/modal';
import { usePredefinedToasts } from 'utils/Toast';

interface Values {
  name: string;
}

interface Props extends ModalProps {
  categoryId: string;
  categoryName: string;
  closeModal: (
    param?: { action: 'CLOSE' } | { action: 'CREATED'; id: string },
  ) => void;
}

export const CreateCustomCategoryValueModal: FC<Props> = ({
  categoryId,
  categoryName,
  closeModal,
}) => {
  const { t } = useTranslation();
  const predefinedToasts = usePredefinedToasts();

  const { control, handleSubmit } = useForm<Values>({
    defaultValues: { name: '' },
  });

  const { mutate: createCustomCategoryValue, isLoading } =
    useCreateCustomCategoryValue();

  const onSubmit: SubmitHandler<Values> = (values) => {
    createCustomCategoryValue(
      {
        categoryId,
        value: values.name,
      },
      {
        onSuccess: ({ data }) => {
          predefinedToasts.success.added();
          return closeModal({ action: 'CREATED', id: data.id });
        },
      },
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Modal.Content
        title={t('actions.add_new_value')}
        actions={[
          {
            variant: 'neutral-outline',
            onClick: () => closeModal({ action: 'CLOSE' }),
            label: t('common.cancel'),
          },
          {
            variant: 'primary',
            label: t('common.confirm'),
            type: 'submit',
            disabled: isLoading,
          },
        ]}
      >
        <Controller
          name="name"
          control={control}
          render={({ field: { name, value, onChange, ref } }) => {
            return (
              <TextField
                placeholder={categoryName}
                name={name}
                value={value}
                onChange={onChange}
                required
                fullWidth
                ref={ref}
              />
            );
          }}
        />
      </Modal.Content>
    </form>
  );
};
